import React from 'react';

import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import styled, { css } from 'styled-components';

import {
  CategoryDropdown as BaseCategoryDropdown,
  useProductBrowser,
} from '~/techstyle-shared/react-components';

const linkStyle = css`
  ${({ theme }) => theme.gridStyles.categoryDropdownLinkStyle}
`;

const CategoryTitle = styled(BaseCategoryDropdown.Title)`
  text-align: center;
  font-family: ${({ theme }) => theme.fontStacks.alternateFamily};
  font-size: 20px;
  font-weight: bold;
`;

const buttonStyle = css`
  color: ${({ theme }) => theme.colors.textDefault};
  background-color: ${({ theme }) => theme.colors.palette.white};
  padding: 19px 0;
  box-shadow: none;
  font-size: inherit;

  &[aria-expanded='true'] {
    box-shadow: none;
    background-color: ${({ theme }) => theme.colors.palette.white};
    color: inherit;
  }
`;

const dropdownStyle = css`
  padding-left: 8px;
  padding-right: 7px;
  padding-top: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08), inset 0 1px 0 0 #e6e6e6;
`;

const CollapseArrow = styled(IoIosArrowUp)`
  color: inherit;
`;

const ExpandArrow = styled(IoIosArrowDown)`
  color: inherit;
`;

function CategoryDropdown(props) {
  const { openOverlay, closeOverlay } = useProductBrowser();
  return (
    <BaseCategoryDropdown
      activeCategoryChecker={(category) => category.urlPath}
      title={
        <CategoryTitle
          buttonStyle={buttonStyle}
          collapseIcon={CollapseArrow}
          expandIcon={ExpandArrow}
          {...props}
        />
      }
      dropdownStyle={dropdownStyle}
      linkStyle={linkStyle}
      onOpen={openOverlay}
      onClose={closeOverlay}
      {...props}
    />
  );
}

export default CategoryDropdown;
